import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import HRManagementBanner from "./HRManagementBanner";
import HRManagementInfo from "./HRManagementInfo";
function HRManagementTool() {
    return (
        <>
            <Header />
            <main>
                <HRManagementBanner/>
                <HRManagementInfo/>
            </main>
            <Footer />
        </>
    );
}

export default HRManagementTool;
